import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import subtractWeeks from 'date-fns/sub_weeks';

import { DataBlocks, Table, Tooltip, I18n } from 'components';

import {
  formatPhone,
  formatDateString,
} from 'utils/formatString';

import {
  updatePeriodStart,
  updatePeriodEnd,
  fetchExpenses,
} from '../../actions';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

class LastExpenses extends Component {
  componentDidMount() {
    const { actions } = this.props;

    const weekAgoDate = subtractWeeks(new Date(), 1);

    actions.updatePeriodStart(weekAgoDate);
    actions.updatePeriodEnd(new Date(), 'YYYY-MM-DD');
    actions.fetchExpenses();
  }

  render() {
    const { details, actions } = this.props;

    return (
      <DataBlocks.Block
        title={<I18n path="detalization.lastExpenses.blockTitle" />}
        refreshAction={actions.fetchPayments}
        isLoading={!details}
      >
        {details && details.length ? (
          <Table
            data={details.filter((row) => row.balances[0].valueChange < 0).slice(0, 5)}
            config={{
              columns: [
                {
                  name: 'Дата и время',
                  dataField: 'dateTime',
                  transformer: (row) => formatDateString(row.dateTime, 'DD.MM.YYYY HH:mm:ss'),
                  width: '90px',
                },
                {
                  name: 'Вид операции',
                  dataField: 'operation',
                  transformer: (row) => {
                    const { operation, number } = row;
                    if (number) {
                      return (
                        <>
                          {operation.replace(/\s*-$/, '')}
                          <Tooltip width="150">
                            {number.substring(0, 2) === '79' && number.length === 11
                              ? formatPhone(number.substring(1, 11))
                              : number}
                          </Tooltip>
                        </>
                      );
                    }
                    return operation;
                  },
                },
                {
                  name: 'Сумма',
                  dataField: 'balances',
                  transformer: (row) => `${row.balances[0].valueChange} ₽`,
                },
              ],
              uniqueIdField: 'dateTime',
              nameAsTranslationKey: false,
            }}
          />
        ) : (
          <div className={cx('emptyMessage')}>
            <I18n path="detalization.payments.emptyMessage" />
          </div>
        )}
      </DataBlocks.Block>
    );
  }
}

function mapStateToProps(state) {
  return {
    details: state.detalization.expenses.callDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      updatePeriodStart,
      updatePeriodEnd,
      fetchExpenses,
    }, dispatch),
  };
}

LastExpenses.propTypes = {
  details: PropTypes.array,
  actions: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(LastExpenses);
